import React from 'react';

import BonosVentas  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/BonoVenta/List.js';

export default function () {
  return <BonosVentas  />;
}